import React from 'react';
import Typography from '@mui/material/Typography';


export function CxTitle({ children, ...props }) {
    return (
        <Typography variant="h4" {...props}>
            {children}
        </Typography>
    );
}

export function CxSubtitle({ children, ...props }) {
    return (
        <Typography variant="h6" {...props}>
            {children}
        </Typography>
    );
}

export function CxSection({ children, sx, ...props }) {
    return (
        <Typography
            variant="subtitle1"
            sx={{ fontWeight: 'bold', ...sx}}
            {...props}
        >
            {children}
        </Typography>
    );
}

export function CxCaption({ children, ...props }) {
    return (
        <Typography
            variant="subtitle2"
            sx={{ color: 'text.secondary'}}
            {...props}
        >
            {children}
        </Typography>
    );
}

export function CxText({ children, sx, ...props }) {
    return (
        <Typography sx={{...sx}} {...props}>
            {children}
        </Typography>
    );
}

export function CxBoldText({ children, sx, ...props }) {
    return (
        <Typography
            sx={{fontWeight: 'bold', ...sx}}
            {...props}
        >
            {children}
        </Typography>
    );
}

export function CxSmallText({ children, ...props }) {
    return (
        <Typography
            variant="caption"
            {...props}
        >
            {children}
        </Typography>
    );
}

export function CxInfo({ children, ...props }) {
    return (
        <Typography
            variant="body2"
            sx={{ color: 'text.secondary'}}
            {...props}
        >
            {children}
        </Typography>
    );
}


export function CxSpacer(){
    return <Typography sx={{ flexGrow: 1 }}></Typography>
}
